import { useParams } from 'react-router-dom'
import { FormSkeleton } from 'src/pages/budget/components'
import {
  useRequestByIdGate,
  useCurrentRequest,
} from 'src/pages/budget/budgetRequests/hooks'
import { RequestPaymentWidget } from 'src/pages/budget/budgetPaymentRequest/widgets'

export const CreatePaymentRequest = () => {
  const { id } = useParams<{ id: string }>()
  useRequestByIdGate(id)

  const request = useCurrentRequest()

  if (!request) {
    return <FormSkeleton />
  }

  return <RequestPaymentWidget request={request} />
}
